import { PropTypes } from 'prop-types';
import React from 'react';

import { transformArticleData } from '../../utils';
import CardImageBasedSmall from '../Cards/CardImageBased/CardImageBasedSmall';

const HomepageHeroFeatured = ({ articles }) => {
  return (
    <div data-module-id="homepage_hero_featured">
      <h4 className="lg:mb-10 mb-8 pb-3.5 border-b stink-h4 border-smoke">
        Featured
      </h4>
      <div
        className="grid lg:grid-cols-1 grid-cols-2 sm:grid-cols-4 gap-x-3.75 sm:gap-x-5 lg:gap-x-10"
        data-component-id="homepage_featured_article"
      >
        {articles.map((article, index) => {
          const { cardImage, franchise, id, slug, tags, title } =
            transformArticleData(article);
          const card = (
            <CardImageBasedSmall
              franchise={franchise}
              image={cardImage}
              slug={slug}
              tags={tags}
              title={title}
            />
          );
          switch (index) {
            case 0:
              return (
                <div
                  key={id}
                  className="order-1 col-span-1 row-span-1 mb-8 sm:mb-13 lg:mb-8"
                >
                  {card}
                </div>
              );
            case 1:
              return (
                <div
                  key={id}
                  className="order-1 col-span-1 row-span-1 mb-8 sm:mb-13 lg:mb-8"
                >
                  {card}
                </div>
              );
            case 2:
              return (
                <div
                  key={id}
                  className="order-3 sm:order-1 lg:order-2 sm:col-span-1 sm:row-span-1 sm:mb-13 lg:mb-8"
                >
                  {card}
                </div>
              );
            case 3:
              return (
                <div
                  key={id}
                  className="order-2 col-span-1 row-span-1 sm:order-1 lg:order-3 sm:mb-13 lg:mb-0"
                >
                  {card}
                </div>
              );
            case 4:
              return (
                <div
                  key={id}
                  className="order-2 hidden sm:col-span-1 sm:row-span-1 sm:mb-13 sm:block lg:hidden"
                >
                  {card}
                </div>
              );
            case 5:
              return (
                <div
                  key={id}
                  className="order-2 hidden sm:col-span-1 sm:row-span-1 sm:mb-13 sm:block lg:hidden"
                >
                  {card}
                </div>
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};

HomepageHeroFeatured.propTypes = {
  articles: PropTypes.array,
};

export default HomepageHeroFeatured;
